import styled from 'styled-components';

export const BaseLayoutWrapper = styled.div`
  ${({ theme }) => theme.fonts.parse('sansSerif', 'regular')}
`;

export default BaseLayoutWrapper;
